import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { ApiAppService } from "app/servicios/apiapp.service";
import * as myGlobals from "app/modelos/globales.modelo";
import { ICliente } from "app/modelos/cliente.modelo";

@Injectable()
export class AuthenticationGuard  {
  constructor(
    private _ApiAppService: ApiAppService,
    private _router: Router,
  ) {}

  // Este es el método que usará angular para permitir el acceso o no a la ruta.
  // Validaremos los datos del clientes a través de la url, en el caso de que no estén cargados volvermos a recargar todos los datos
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (myGlobals.isNullUndefined(myGlobals.getInfoCliente())) {
      this._router.navigate(["/"]);
      return false;
    } else {
      return true;
    }
  }
}
